export default "__VITE_ASSET__XTR7qjyu__"